import {useSearchFormContext} from '../../../hooks/useSearchFormContext';
import {getDatesSummaryAndNightCountLabel} from '../../../utils/dates';

function useComponent(props) {
    const {
        datesTranslations: {
            nightsText
        },
        mediaSettings: {
            isMobile
        },
        latestDatesValues: {
            startDate,
            endDate
        },
        systemOptions: {
            locale
        }
    } = useSearchFormContext();

    const {data} = props;

    const endDateValue = data && data.endDate || endDate;

    const message = endDateValue ?
        getDatesSummaryAndNightCountLabel(startDate, endDateValue, locale, nightsText)
        : '';

    const result = {
        message,
        isMobile
    };

    return result;
}

export {useComponent};